export default __webpack_public_path__ + "static/media/Path 88.85d981f0.svg";